module.exports = __webpack_public_path__ + "img/service_wechat.3438987c.jpg";